<template>
    <header class="header-custom">
        <v-app-bar app flat dense color="#b297ff" dark>
            <v-app-bar-nav-icon @click="mini = !mini"></v-app-bar-nav-icon>
            <v-spacer></v-spacer>
            <router-link
                to="/admin/editadminuserprofile"
                style="text-decoration:none;"
            >
                <v-btn class="pa-0 name" text style="color:primary">
                    <v-toolbar-title
                        class="mr-4 ml-3"
                        right
                        style="font-size:14px;color:primary"
                    >
                        {{ auth.adminUser.adminUserFirstName }}
                    </v-toolbar-title>
                </v-btn>
            </router-link>
        </v-app-bar>

        <v-navigation-drawer
            app
            permanent
            v-model="drawer"
            :mini-variant.sync="mini"
            mini-variant-width="56"
            width="250"
        >
            <template v-if="mini">
                <v-list-item
                    class="px-0 py-0 mx-0 my-0"
                    style="background: #fff"
                >
                    <router-link to="/admin/dashboard">
                        <v-img
                            src="../../../public/E-swar-logo.png"
                            width="58"
                            height="51"
                            contain
                            dark
                            bordered
                        >
                        </v-img>
                    </router-link>
                </v-list-item>
            </template>

            <template v-else>
                <v-list-item class="px-0 py-0" dark style="background:#fff">
                    <router-link to="/admin/dashboard">
                        <v-img
                            :aspect-ratio="300 / 52"
                            src="../../../public/eswar-logo-extended-3-resized.png"
                            width="300"
                            height="51"
                            contain
                            dark
                            style="align:center"
                        ></v-img>
                    </router-link>
                </v-list-item>
            </template>

            <v-list class="v-list-custom">
                <v-list-item-group color="primary">
                    <v-list-item
                        v-for="item in items"
                        :key="item.text"
                        :to="item.to"
                    >
                        <v-list-item-action>
                            <v-icon v-text="item.icon"></v-icon>
                        </v-list-item-action>
                        <v-list-item-title v-text="item.text">
                        </v-list-item-title>
                    </v-list-item>
                </v-list-item-group>
            </v-list>

            <template v-slot:append>
                <div>
                    <v-btn block class="btn-logout" @click="logOut()">
                        <v-icon class="btn-logout-icon">mdi-logout</v-icon>
                        Logout
                    </v-btn>
                </div>
            </template>
        </v-navigation-drawer>
    </header>
</template>

<script>
import { mapMutations } from "vuex";
import url1 from "../../../config.js";

export default {
    beforeRouteEnter(to, from, next) {
        next(vm => {
            setTimeout(() => {
                if (!vm.$store.state.auth.adminUser._id) vm.$router.push("/");
            }, 0);
        });
    },

    name: "AdminHeader",

    data: () => ({
        url: url1.url,
        drawer: true,
        mini: true,
        loggedInUser: "",
        items: [
            {
                //url:`${url1.url}`,
                text: "Dashboard",
                to: "/admin/dashboard",
                icon: "mdi-speedometer"
            },

            {
                text: "Courses",
                to: "/admin/courses",
                icon: "mdi-school"
            },
            {
                text: "Lessons",
                to: "/admin/lessons",
                icon: "mdi-book-open-variant"
            },
            {
                text: "Questions",
                to: "/admin/questions",
                icon: "mdi-file-question"
            },
            {
                text: "Users",
                to: "/admin/users",
                icon: "mdi-account-multiple"
            },

            {
                text: "Subscription Settings",
                to: "/admin/packageprice",
                icon: "mdi-briefcase"
            },

            {
                text: "Discounts",
                to: '/admin/discounts',
                icon: 'mdi-margin',
            },
            {
                text: "Payments",
                to: "/admin/payments",
                icon: "mdi-currency-usd"
            },

            {
                text: "Pop ups",
                to: "/admin/reminderpopups",
                icon: "mdi-clock"
            },

            {
                text: "Location/Feedback",
                to: "/admin/locationfeedback",
                icon: "mdi-map-marker"
            },
            {
                text: "Terms & Conditions",
                to: "/admin/termsandcondition",
                icon: "mdi-clipboard-text-multiple-outline"
            },
            {
                text: "Privacy Policy",
                to: "/admin/privacypolicy",
                icon: "mdi-clipboard-text-multiple-outline"
            },
            {
                text: "About",
                to: "/admin/about",
                icon: "mdi-clipboard-text-multiple-outline"
            },
            {
                text: "Theory Notes",
                to: "/admin/theorynotes",
                icon: "mdi-clipboard-text-multiple-outline"
            },


        ]
    }),

    computed: {
        auth() {
            //console.warn('state auth' ,  this.$store.state.auth);
            return this.$store.state.auth;
        }
    },

    methods: {
        ...mapMutations(["removeAuth"]),

        logOut() {
            localStorage.removeItem("token");
            this.removeAuth();
            if (this.$route.fullPath !== "/") this.$router.push("/");
        }
    },
    mounted() {
        // this.setLoggedInUserName();
    }
};
</script>
<style scoped>
.header-custom >>> .v-navigation-drawer__content {
    background: #b297ff;
}
.header-custom >>> .v-icon.v-icon {
    font-size: 18px;
}
.header-custom >>> .v-list-item__action {
    margin-right: 6px;
}
.btn-logout {
    padding: 5px 0 !important;
    height: 40px !important;
    justify-content: start;
    background: #8e79cc !important;
    box-shadow: none;
    color: #fff;
    border-radius: 0;
    text-transform: none;
}

.btn-logout:hover {
    background: #223f7d !important;
}
.btn-logout-icon {
    padding: 0 20px;
}
.px-2.v-list-item.theme--dark {
    padding: 4px !important;
}
.v-list-custom {
    padding: 0;
}
.v-list-custom >>> .theme--light.v-icon,
.v-list-custom >>> .v-list-item,
.v-list-custom >>> .v-list-item__title {
    color: #e3e3e3;
}
.v-list-custom >>> .v-list-item__title {
    font-size: 14px;
}
.v-list-custom >>> .v-list-item--link:before,
.btn-logout:before {
    background: transparent !important;
}
.v-list-custom >>> .v-list-item:hover {
    color: #fff !important;
    background: rgba(0, 0, 0, 0.2);
}
.v-list-custom >>> .v-list-item.v-item--active {
    background: rgba(0, 0, 0, 0.2);
    color: #fff !important;
}
.v-list-custom >>> .v-list-item:hover .theme--light.v-icon,
.v-list-custom >>> .v-list-item:hover .v-list-item__title,
.v-list-custom >>> .v-list-item.v-item--active .v-list-item__title,
.v-list-custom >>> .v-list-item .v-list-item__title {
    color: #fff !important;
}
header >>> header {
    height: 50px !important;
}
.v-list-custom >>> .v-card__text {
    font-size: 16px;
}
.name {
    text-transform: none;
}
.v-list-custom >>> .v-icon {
    color: #fff !important;
}
</style>
